module.exports = __webpack_public_path__ + "static/vistalateral-e6e8c839cb2243109d01b02774ceb40d.webp";